<template lang="pug">
  .dialog-container(id="ApplyExtensionDialog-container")
    h4 {{$t('Pick extension')}}:
    hr.header
    el-tabs(type='border-card')
      el-tab-pane
        span(slot='label')
          font-awesome-icon(icon="wifi")
          span &nbsp; {{$t('Local extensions')}}
        .row
          .cell.th.name  {{ $t('Name') }}
          .cell.th.description  {{ $t('Description') }}
          .cell.th.version  {{ $t('Version') }}
          .cell.th.playlist  {{ $t('Playlist') }}
        .row(v-for="extension in extensionsLocal", :id="'ApplyExtensionDialog-localExtensionRow' + extension.id", :key="extension.id", :class="{ selected: isSelected(extension) }", @click="selectExtension(extension)")
          .cell.name {{ extension.name }}
          .cell.description {{ extension.description ? extension.description : '-' }}
          .cell.version {{ extension.version }}
          .cell.playlist
            font-awesome-icon(v-if="extension.isPlayListExtension", icon="check")
      el-tab-pane
        span(slot='label')
          font-awesome-icon(icon="wifi")
          span &nbsp; {{$t('Global extensions')}}
        .row
          .cell.th.name  {{ $t('Name') }}
          .cell.th.description  {{ $t('Description') }}
          .cell.th.version  {{ $t('Version') }}
          .cell.th.playlist  {{ $t('Playlist') }}
        .row(v-for="extension in extensionsGlobal", :id="'ApplyExtensionDialog-globalExtensionRow' + extension.id", :key="extension.id", :class="{ selected: isSelected(extension) }", @click="selectExtension(extension)")
          .cell.name {{ extension.name }}
          .cell.description {{ extension.description ? extension.description : '-' }}
          .cell.version {{ extension.version }}
          .cell.playlist
            font-awesome-icon(v-if="extension.isPlayListExtension", icon="check")
    .bottom-row
      el-button(type="success", size="mini", id="ApplyExtensionDialog-submitButton", :disabled='saving || !selectedExtension', @click="assignExtensionToNetwork")
        span {{ !saving ? $t("Add to network") : $t("saving...")}}
</template>

<script>

import Vue from 'vue'

export default {
  props: [],
  components: {
  },
  async created () {
    await this.loadData()
  },
  data () {
    return {
      errors: {
      },
      saving: false,
      extensions: undefined,
      selectedExtension: undefined
    }
  },
  methods: {
    isSelected (extension) {
      if (!this.selectedExtension) return false
      return this.selectedExtension.id === extension.id
    },
    selectExtension (extension) {
      this.selectedExtension = extension
    },
    async loadData () {
      const path = 'extension/getUserMaxVersions'
      await Vue.axios
        .get(path)
        .then(response => {
          this.extensions = response.data
        })
    },
    async assignExtensionToNetwork () {
      this.$emit('linkerJobStarted')
      if (!this.selectedExtension) return
      this.saving = true
      try {
        await Vue.axios.post('extension/createMedium', {
          libraryFolderId: this.$store.state.Medium.selected_library_folder.id,
          extensionId: this.selectedExtension.id
        })
      } finally {
        this.$emit('linkerJobDone', 'create')
      }
      this.saving = false
    }
  },
  computed: {
    extensionsLocal () {
      if (!this.extensions) return []
      return this.extensions.filter(e => e.Network > 0)
    },
    extensionsGlobal () {
      if (!this.extensions) return []
      return this.extensions.filter(e => e.Network < 1)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
@import "./dialog.scss";
.selected {
  background-color: rgba(#ffffff, 0.08)
}
.row, .bottom-row {
  display: flex;
  // height: 50px;
  align-items:center;
  .cell {
    padding: 10px;
    &.name {
      width: 150px;
    }
    &.description {
      width: 750px;
    }
    &.version {
      width: 80px;
    }
  }
  .th {
    color: $--color-text-secondary;
  }
}
.row {
  border-bottom: $--border-light;
}
.bottom-row {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Linker/ApplyExtensionDialog.vue